import { Component, computed, input } from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import {
  IconBackComponent,
  IconBanComponent,
  IconEyeComponent,
  IconPrintComponent,
} from '@pedix-workspace/angular-ui-icons';
import { ActionSheetComponent } from '@pedix-workspace/angular-ui-action-sheet';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { TaxVoucher } from '@pedix-workspace/utils';
import { arcaVoucherTypeOptions } from '@pedix-workspace/integrations-arca';

@Component({
  selector: 'app-order-details-tax-voucher-actions',
  templateUrl: './order-details-tax-voucher-actions.component.html',
  styleUrls: ['./order-details-tax-voucher-actions.component.scss'],
  standalone: true,
  imports: [
    TranslocoDirective,
    ActionSheetComponent,
    ButtonComponent,
    IconBackComponent,
    IconEyeComponent,
    IconPrintComponent,
    IconBanComponent,
  ],
})
export class OrderDetailsTaxVoucherActionsComponent {
  taxVoucher = input.required<TaxVoucher>();

  readonly taxVoucherType = computed(() => {
    return (
      arcaVoucherTypeOptions.find(option => option.id === this.taxVoucher().type)?.name || '--'
    );
  });
  readonly taxVoucherRef = computed(() => this.taxVoucher().voucherRef.toString().padStart(8, '0'));
}
